import * as React from 'react';

import PropTypes from 'prop-types';

class SlideOne extends React.Component {
    static propTypes = {
        onDismiss: PropTypes.func,
        onNext: PropTypes.func,
    };

    render() {
        return (
            <div className='slide-one'>
                <div className='slide-one-graphic slide-graphic' />
                <h1>Welcome to the funnel report</h1>
                <p>Monitor the state of your pipeline, and measure how leads flow through it.</p>
                <button
                    role='button'
                    className='ui-btn ui-btn--grey ui-btn--xlarge'
                    onClick={this.props.onDismiss}
                >
                    <span>Let me see it now!</span>
                </button>
                <button
                    role='button'
                    className='ui-btn ui-btn--blue ui-btn--xlarge'
                    onClick={this.props.onNext}
                >
                    <span>Next</span>
                </button>
            </div>
        );
    }
}

class SlideTwo extends React.Component {
    static propTypes = {
        onPrevious: PropTypes.func,
        onNext: PropTypes.func,
    };

    render() {
        return (
            <div className='slide-two'>
                <div className='slide-two-graphic slide-graphic' />
                <h1>See the value & volume of each stage</h1>
                <p>
                    Each bar represents the quantity of leads that flowed through the stage in a
                    given period.
                </p>
                <button
                    role='button'
                    className='ui-btn ui-btn--grey ui-btn--xlarge'
                    onClick={this.props.onPrevious}
                >
                    <span>Previous</span>
                </button>
                <button
                    role='button'
                    className='ui-btn ui-btn--blue ui-btn--xlarge'
                    onClick={this.props.onNext}
                >
                    <span>Next</span>
                </button>
            </div>
        );
    }
}

class SlideThree extends React.Component {
    static propTypes = {
        onPrevious: PropTypes.func,
        onNext: PropTypes.func,
    };

    render() {
        return (
            <div className='slide-three'>
                <div className='slide-three-graphic slide-graphic' />
                <h1>Track how leads progress</h1>
                <p>Monitor how many leads advance to each stage.</p>
                <button
                    role='button'
                    className='ui-btn ui-btn--grey ui-btn--xlarge'
                    onClick={this.props.onPrevious}
                >
                    <span>Previous</span>
                </button>
                <button
                    role='button'
                    className='ui-btn ui-btn--blue ui-btn--xlarge'
                    onClick={this.props.onNext}
                >
                    <span>Next</span>
                </button>
            </div>
        );
    }
}

class SlideFour extends React.Component {
    static propTypes = {
        onPrevious: PropTypes.func,
        onDismiss: PropTypes.func,
    };

    render() {
        return (
            <div className='slide-four'>
                <div className='slide-four-graphic slide-graphic' />
                <h1>See when leads close</h1>
                <p>
                    Track and compare how often your sales are won or lost at each stage of the
                    funnel.
                </p>
                <button
                    role='button'
                    className='ui-btn ui-btn--grey ui-btn--xlarge'
                    onClick={this.props.onPrevious}
                >
                    <span>Previous</span>
                </button>
                <button
                    role='button'
                    className='ui-btn ui-btn--green ui-btn--xlarge'
                    onClick={this.props.onDismiss}
                >
                    <span>Awesome! Let me see.</span>
                </button>
            </div>
        );
    }
}

export {SlideOne, SlideTwo, SlideThree, SlideFour};
